import ErrorMessages from "../../error-messages";
import Guard from "../../guard";
import { IEntity } from "./entity";

export class LazyLoadingManager {
    static ensureLazyLoadingIsPossible(entity: IEntity): void {
        Guard.notNullOrUndefined(entity);
        if (!entity.canDoLazyLoading) {
            throw ErrorMessages.Entity.CannotLazyLoad;
        }
    }
}
